/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Generating_ProxyInputs */



/**
* | output |
* | --- |
* | "Generating Proxy Stream..." |
*
* @param {Load_Project_File_Status_Generating_ProxyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_generating_proxy = /** @type {((inputs?: Load_Project_File_Status_Generating_ProxyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Generating_ProxyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generation du flux proxy...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy-Stream wird generiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Generazione del flusso proxy...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Генерация прокси-потока...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Generando flujo proxy...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在生成代理流...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシ ストリームを生成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी स्ट्रीम जनरेट हो रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerando fluxo proxy...")
	return /** @type {LocalizedString} */ ("Generating Proxy Stream...")
});